import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgTrophy({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 3v1.999L22 5v3a7.004 7.004 0 01-5.065 6.729 6.485 6.485 0 01-3.934 2.194L13 19h1a2 2 0 011.995 1.85L16 21H8a2 2 0 012-2h1v-2.076a6.49 6.49 0 01-3.937-2.196 7.003 7.003 0 01-5.059-6.483L2 8V5l3.5-.001V3h13zm-2 2h-9v5.5a4.5 4.5 0 109 0V5zm2 5.5c0 .4-.036.792-.105 1.172a4.999 4.999 0 001.6-3.444L20 8V7l-1.5-.001V10.5zm-13-3.501L4 7v1c0 1.44.614 2.753 1.605 3.671A6.595 6.595 0 015.5 10.5V6.999z"
        fill={color}
      />
    </svg>
  )
}

export default SvgTrophy
